<div
  class="flex items-center justify-between w-full space-x-2"
  [ngClass]="{
    'opacity-50 select-none pointer-events-none': formControl.disabled
  }"
>
  <input
    #rangeElement
    class="grow h-0.5 bg-white/5 appearance-none outline-none cursor-pointer
      [&::-webkit-slider-thumb]:h-2
      [&::-webkit-slider-thumb]:w-2
      [&::-webkit-slider-thumb]:rounded-full
      [&::-webkit-slider-thumb]:appearance-none
      [&::-webkit-slider-thumb]:bg-[#b3d2d8]"
    type="range"
    [id]="id"
    [name]="name"
    [min]="min"
    [max]="max"
    [formControl]="formControl | formControl"
    (change)="onSliderChange($event)"
    (input)="onSliderInput($event)"
  >

  @if (isLabeled) {
    <div class="flex items-center justify-between">
      <input class="w-12 h-4 p-0 text-sm tracking-wide text-white bg-transparent border-none text-end" type="text" [formControl]="formControl | formControl" (input)="onInputChange($event)">

      @if (label) {
        <span class="text-sm tracking-wide">{{ label }}</span>
      }
    </div>
  }
</div>
